import { css } from 'styled-components';
import { setCssVar } from './cssVar';
import greyscale from './grey';
const brand = {
    black: '#231f20',
    blueGrey: '#eff1f1',
    gold: '#a29161',
    grey: greyscale,
    magenta: '#89166e',
    purple: '#57154a',
    white: '#fff',
    validation: {
        invalid: '#da291c',
        valid: '#008c15',
    },
};
export const lightTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('bgColorAlt', brand.magenta)};
  ${setCssVar('accentColor', brand.magenta)};
  ${setCssVar('accentColorAlt', brand.purple)};
`;
export const darkTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.black)};
  ${setCssVar('accentColor', brand.magenta)};
  ${setCssVar('accentColorAlt', brand.purple)};
`;
export const magentaTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.magenta)};
  ${setCssVar('accentColor', brand.magenta)};
  ${setCssVar('accentColorAlt', brand.purple)};
`;
export const patternTheme = css `
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('bgColor', brand.white)};
  ${setCssVar('accentColor', brand.magenta)};
  ${setCssVar('accentColorAlt', brand.purple)};
`;
export const purpleTheme = css `
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('bgColor', brand.purple)};
  ${setCssVar('accentColor', brand.magenta)};
  ${setCssVar('accentColorAlt', brand.purple)};
`;
export const themes = {
    dark: darkTheme,
    light: lightTheme,
    magenta: magentaTheme,
    pattern: patternTheme,
    purple: purpleTheme,
};
export default brand;
